import React, { useState, useEffect, useRef, createContext } from "react";

const MarketsContext = createContext();

export const MarketsConsumer = MarketsContext.Consumer;

const MarketsProvider = (props) => {
  const [market, setMarket] = useState([]);

  return (
    <MarketsContext.Provider
      value={{
        market,
        setMarket,
      }}
    >
      {props.children}
    </MarketsContext.Provider>
  );
};

export default MarketsContext;

export { MarketsProvider, MarketsContext };
